export default __webpack_public_path__ + "static/media/graduation_hat@3x.04e216ff.png";